<p-tabView [(activeIndex)]="activeTipoIndex" (onChange)="onTabChange($event)">
    <p-tabPanel header="Sopralluoghi">
        <p-tabView [(activeIndex)]="activeBandoIndex" (onChange)="onBandoTabChange($event)">
          <p-tabPanel header="Bando 1">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
              <div>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="listeService.opzioniRegioneProntofibra"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerRegioneSop($event.value)"
                  placeholder="Regione"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroRegioneSop"
                  [disabled]="isLoadingSop">
                  <ng-template let-item pTemplate="item">
                    <span class="font-['Poppins']" [style]="{
                      'background-color': '#85C7E7',
                      'color': '#191a1b',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '700',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block'
                    }">{{ item.label | uppercase }}</span>
                  </ng-template>
                  <ng-template let-selectedItem pTemplate="selectedItem">
                    <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                      'background-color': '#85C7E7',
                      'color': '#191a1b',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '700',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block'
                    }">{{ selectedItem.label | uppercase }}</span>
                  </ng-template>
                </p-dropdown>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="opzioniImpreseBando1Sop"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerImpresaSop($event.value)"
                  placeholder="Impresa"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroImpresaSop"
                  [disabled]="isLoadingSop">
                  <ng-template let-item pTemplate="item">
                    <span class="font-['Poppins']" [style]="{
                      'background-color': '#5f9ea0',
                      'color': '#ffffff',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '700',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block'
                    }">{{ item.label | uppercase }}</span>
                  </ng-template>
                  <ng-template let-selectedItem pTemplate="selectedItem">
                    <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                      'background-color': '#5f9ea0',
                      'color': '#ffffff',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '700',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block'
                    }">{{ selectedItem.label | uppercase }}</span>
                  </ng-template>
                </p-dropdown>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="opzioniTipoSedeBando1Sop"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerTipoSedeEffettivaSop($event.value)"
                  placeholder="Tipo Sede"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroTipoSedeEffettivaSop"
                  [disabled]="isLoadingSop">
                  <ng-template let-item pTemplate="item">
                    <span class="font-['Poppins']" [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#191a1b',
                      'border': '1px solid #0A0A0A',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '600',
                      'font-size': '12px',
                      'letter-spacing': '.2px',
                      'display': 'inline-block'
                    }">{{ item.label }}</span>
                  </ng-template>
                  <ng-template let-selectedItem pTemplate="selectedItem">
                    <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#191a1b',
                      'border': '1px solid #0A0A0A',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '600',
                      'font-size': '12px',
                      'letter-spacing': '.2px',
                      'display': 'inline-block'
                    }">{{ selectedItem.label }}</span>
                  </ng-template>
                </p-dropdown>
                <button *ngIf="filterIsSetSop" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
style="background-color: #607D8B; border-color: #455A64; color: #ffffff; font-size: 13px; min-height: 2.5rem; height: 2.5rem; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
                  pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilterSop()"
                ></button>
              </div>
              <div class="p-2" style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: 0.25rem; height: 100%;">
                <ng-container *ngIf="!filterIsSetSop">
                  <span class="font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">TUTTE LE REGIONI</span>
                </ng-container>
                <ng-container *ngIf="filterIsSetSop">
                  <span *ngIf="filtroRegioneSop" class="font-['Poppins']" [style]="{'background-color': '#85C7E7', 'color': '#191a1b', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '700', 'font-size': '13px', 'letter-spacing': '.3px', 'display': 'inline-block', 'border': '1px solid #191a1b'}">{{ filtroRegioneSop | uppercase }}</span>
                  <span *ngIf="filtroImpresaSop != null && filtroImpresaSop !== undefined" class="font-['Poppins']" [style]="{'background-color': '#5f9ea0', 'color': '#ffffff', 'border': '1px solid #191a1b', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '700', 'font-size': '13px', 'letter-spacing': '.3px', 'display': 'inline-block'}">{{ labelImpresaSelezionataSop | uppercase }}</span>
                  <span *ngIf="filtroTipoSedeEffettivaSop" class="font-['Poppins']" [style]="{'background-color': '#EBEBEB', 'color': '#191a1b', 'border': '1px solid #0A0A0A', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '600', 'font-size': '12px', 'letter-spacing': '.2px', 'display': 'inline-block'}">{{ filtroTipoSedeEffettivaSop | uppercase }}</span>
                </ng-container>
              </div>
              <button 
                pButton type="button" icon="pi pi-cloud-download"
                pTooltip="Esporta i dati" tooltipPosition="top"
                class="font-['Poppins']"
                style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
                (click)="scaricaReportSopralluoghi()" 
              ></button>
            </div>
            <!-- Tabella Sopralluoghi Bando 1 -->
            <p-table styleClass="p-datatable-sm" 
              [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
              [paginator]="false" [loading]="isLoadingSop" [value]="datiRaggruppatiBando1SopFiltrati" dataKey="impresa">
              <!-- HEADER -->
              <ng-template pTemplate="header">
                <tr>
                  <th class="text-left font-['Poppins']" style="font-size: 11px; width: 20%; ">IMPRESA</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">NO SOPRALLUOGO</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">NO SOPRALLUOGO PF</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">SOPRALLUOGO PIANIFICATO</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">SOPRALLUOGO KO</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">SOPRALLUOGO ESEGUITO</th>
                  <th class="text-center font-['Poppins'] font-bold" style="font-size: 11px;width: 10%;">TOTALE</th>
                </tr>
              </ng-template>
              <!-- BODY -->
              <ng-template pTemplate="body" let-row>
                <tr>
                    <td>
                        <p-tag [value]="row.impresa | uppercase"
                        [style]="{
                            'background-color': '#5f9ea0',
                            'color': '#ffffff',
                            'border-radius': '6px',
                            'padding': '.25em .5rem',
                            'font-weight': '700',
                            'font-size': '13px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer'
                          }"
                           (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                          tooltipPosition="top">
                        </p-tag>
                      </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.noSopralluogo > 0" [value]="row.noSopralluogo"
                      (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'noSopralluogo')"
                      [pTooltip]="!isPresidioTIM && row.noSopralluogo > 0 ?'Apri le pratiche SENZA SOPRALLUOGO di ' + row.impresa:null" tooltipPosition="top"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noSopralluogo > 0 ? 'pointer': 'default'}"
                    ></p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.noSopralluogoPF > 0" [value]="row.noSopralluogoPF"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noSopralluogoPF > 0 ? 'pointer': 'default'}"
                      (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'noSopralluogoPF')"
                      [pTooltip]=" !isPresidioTIM && row.noSopralluogoPF > 0 ? 'Apri le pratiche SENZA SOPRALLUOGO (PF) di ' + row.impresa: null" tooltipPosition="top"
                 
                      ></p-tag>
                  </td>
                
                
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.sopralluogoPianificato > 0" [value]="row.sopralluogoPianificato"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.sopralluogoPianificato > 0 ? 'pointer': 'default'}"
                      (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'sopralluogoPianificato')"
                      [pTooltip]=" !isPresidioTIM && row.sopralluogoPianificato > 0 ? 'Apri le pratiche CON SOPRALLUOGO PIANFICATO di ' + row.impresa: null" tooltipPosition="top"
                   
                      ></p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.sopralluogoKO > 0" [value]="row.sopralluogoKO"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.sopralluogoKO > 0 ? 'pointer': 'default'}"
                      (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'sopralluogoKO')"
                      [pTooltip]=" !isPresidioTIM && row.sopralluogoKO > 0 ? 'Apri le pratiche CON SOPRALLUOGO KO di ' + row.impresa : null"
                      tooltipPosition="top"
                      ></p-tag>
                  </td>

                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.sopralluogoEseguito > 0" [value]="row.sopralluogoEseguito"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.sopralluogoEseguito > 0 ? 'pointer': 'default'}"
                      (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'sopralluogoEseguito')"
                      [pTooltip]=" !isPresidioTIM && row.sopralluogoEseguito > 0 ? 'Apri le pratiche CON SOPRALLUOGO ESEGUITO di ' + row.impresa: null" tooltipPosition="top"
                
                      ></p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.totale > 0" [value]="row.totale"
                      [style]="{
                        'background-color': '#EBEBEB',
                        'color': '#000000',
                        'border-radius': '6px',
                        'border-color':'#0A0A0A',
                        'padding': '.25em .5rem',
                        'font-weight': '700',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'cursor': 'pointer'
                          }"
                           (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                          tooltipPosition="top"></p-tag>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>
                  <td colspan="1" class="text-left" style="font-size: 12px; font-weight: bold;">TOTALI:</td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                    <p-tag
                      [value]="totaliNoSopralluogoBando1"
                      [style]="{
                        'background-color': '#BFC0C0',
                        'color': '#191a1b',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '800',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase1(1,'noSopralluogo')"
                      [pTooltip]="'Apri TUTTE le pratiche SENZA SOPRALLUOGO'"
                      tooltipPosition="top"
                    >
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                    <p-tag [value]="totaliNoSopralluogoPFBando1"
                      [style]="{
                        'background-color': '#7C90A0',
                        'color': '#191a1b',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '800',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase1(1,'noSopralluogoPF')"
                      [pTooltip]="'Apri TUTTE le pratiche SENZA SOPRALLUOGO (PF)'"
                      tooltipPosition="top"
                      >
                  </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                    <p-tag [value]="totaliSopralluogoPianificatoBando1"
                      [style]="{
                        'background-color': '#58A4B0',
                        'color': '#191a1b',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '800',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase1(1,'sopralluogoPianificato')"
                      [pTooltip]="'Apri TUTTE le pratiche CON SOPRALLUOGO PIANFICATO'"
                      tooltipPosition="top"
                      >
                  </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                    <p-tag [value]="totaliSopralluogoKOBando1"
                      [style]="{
                        'background-color': '#F75C03',
                        'color': '#191a1b',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '800',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase1(1,'sopralluogoKO')"
                      [pTooltip]="'Apri TUTTE le pratiche CON SOPRALLUOGO KO'"
                      tooltipPosition="top"
                      >
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                      <p-tag [value]="totaliSopralluogoEseguitoBando1"
                        [style]="{
                          'background-color': '#04A777',
                          'color': '#191a1b',
                          'border-radius': '6px',
                          'padding': '.25em .5rem',
                          'font-weight': '800',
                          'font-size': '13px',
                          'letter-spacing': '.3px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                        }"
                        (click)="!isImpresa && openPraticheFase1(1,'sopralluogoEseguito')"
                        [pTooltip]="'Apri TUTTE le pratiche CON SOPRALLUOGO ESEGUITO'"
                        tooltipPosition="top"
                        >
                    </p-tag>
                  </td>
                 
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                    <p-tag [value]="totaliNoSopralluogoBando1 + totaliNoSopralluogoPFBando1 + totaliSopralluogoPianificatoBando1 + totaliSopralluogoEseguitoBando1 + totaliSopralluogoKOBando1"
                      [style]="{
                        'background-color': '#5f9ea0',
                        'color': '#191a1b',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '800',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                      }"
                      >
                  </p-tag>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>
    
          <p-tabPanel header="Bando 2">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
              <div>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="listeService.opzioniRegioneProntofibra"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerRegioneSop($event.value)"
                  placeholder="Regione"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroRegioneSop"
                  [disabled]="isLoadingSop">
                  <ng-template let-item pTemplate="item">
                    <span class="font-['Poppins']" [style]="{
                      'background-color': '#85C7E7',
                      'color': '#191a1b',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '700',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block'
                    }">{{ item.label | uppercase }}</span>
                  </ng-template>
                  <ng-template let-selectedItem pTemplate="selectedItem">
                    <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                      'background-color': '#85C7E7',
                      'color': '#191a1b',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '700',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block'
                    }">{{ selectedItem.label | uppercase }}</span>
                  </ng-template>
                </p-dropdown>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="opzioniImpreseBando2Sop"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerImpresaSop($event.value)"
                  placeholder="Impresa"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroImpresaSop"
                  [disabled]="isLoadingSop">
                  <ng-template let-item pTemplate="item">
                    <span class="font-['Poppins']" [style]="{
                      'background-color': '#5f9ea0',
                      'color': '#ffffff',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '700',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block'
                    }">{{ item.label | uppercase }}</span>
                  </ng-template>
                  <ng-template let-selectedItem pTemplate="selectedItem">
                    <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                      'background-color': '#5f9ea0',
                      'color': '#ffffff',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '700',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block'
                    }">{{ selectedItem.label | uppercase }}</span>
                  </ng-template>
                  
                </p-dropdown>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="opzioniTipoSedeBando2Sop"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerTipoSedeEffettivaSop($event.value)"
                  placeholder="Tipo Sede"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroTipoSedeEffettivaSop"
                  [disabled]="isLoadingSop">
                  <ng-template let-item pTemplate="item">
                    <span class="font-['Poppins']" [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#191a1b',
                      'border': '1px solid #0A0A0A',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '600',
                      'font-size': '12px',
                      'letter-spacing': '.2px',
                      'display': 'inline-block'
                    }">{{ item.label }}</span>
                  </ng-template>
                  <ng-template let-selectedItem pTemplate="selectedItem">
                    <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#191a1b',
                      'border': '1px solid #0A0A0A',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '600',
                      'font-size': '12px',
                      'letter-spacing': '.2px',
                      'display': 'inline-block'
                    }">{{ selectedItem.label }}</span>
                  </ng-template>
                </p-dropdown>
                <button *ngIf="filterIsSetSop" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
style="background-color: #607D8B; border-color: #455A64; color: #ffffff; font-size: 13px; min-height: 2.5rem; height: 2.5rem; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
                  pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilterSop()"
                ></button>
              </div>
              <div class="p-2" style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: 0.25rem; height: 100%;">
                <ng-container *ngIf="!filterIsSetSop">
                  <span class="font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">TUTTE LE REGIONI</span>
                </ng-container>
                <ng-container *ngIf="filterIsSetSop">
                  <span *ngIf="filtroRegioneSop" class="font-['Poppins']" [style]="{'background-color': '#85C7E7', 'color': '#191a1b', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '700', 'font-size': '13px', 'letter-spacing': '.3px', 'display': 'inline-block', 'border': '1px solid #191a1b'}">{{ filtroRegioneSop | uppercase }}</span>
                  <span *ngIf="filtroImpresaSop != null && filtroImpresaSop !== undefined" class="font-['Poppins']" [style]="{'background-color': '#5f9ea0', 'color': '#ffffff', 'border': '1px solid #191a1b', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '700', 'font-size': '13px', 'letter-spacing': '.3px', 'display': 'inline-block'}">{{ labelImpresaSelezionataSop | uppercase }}</span>
                  <span *ngIf="filtroTipoSedeEffettivaSop" class="font-['Poppins']" [style]="{'background-color': '#EBEBEB', 'color': '#191a1b', 'border': '1px solid #0A0A0A', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '600', 'font-size': '12px', 'letter-spacing': '.2px', 'display': 'inline-block'}">{{ filtroTipoSedeEffettivaSop | uppercase }}</span>
                </ng-container>
              </div>
              <button 
                pButton type="button" icon="pi pi-cloud-download"
                pTooltip="Esporta i dati" tooltipPosition="top"
                class="font-['Poppins']"
                style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
                (click)="scaricaReportSopralluoghi()" 
              ></button>
            </div>
            <!-- Tabella Sopralluoghi Bando 2 -->
            <p-table styleClass="p-datatable-sm" 
              [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
              [paginator]="false" [loading]="isLoadingSop" [value]="datiRaggruppatiBando2SopFiltrati" dataKey="impresa">
              <!-- HEADER -->
              <ng-template pTemplate="header">
                <tr>
                  <th class="text-left font-['Poppins']" style="font-size: 11px; width: 20%; ">IMPRESA</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">NO SOPRALLUOGO</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">NO SOPRALLUOGO PF</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">SOPRALLUOGO PIANIFICATO</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">SOPRALLUOGO KO</th>
                  <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">SOPRALLUOGO ESEGUITO</th>
                  
                  <th class="text-center font-['Poppins'] font-bold" style="font-size: 11px;width: 10%;">TOTALE</th>
                </tr>
              </ng-template>
              <!-- BODY -->
              <ng-template pTemplate="body" let-row>
                <tr>
                    <td>
                        <p-tag [value]="row.impresa | uppercase"
                        [style]="{
                            'background-color': '#5f9ea0',
                            'color': '#ffffff',
                            'border-radius': '6px',
                            'padding': '.25em .5rem',
                            'font-weight': '700',
                            'font-size': '13px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer'
                          }"
                           (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                          tooltipPosition="top">
                        </p-tag>
                      </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.noSopralluogo > 0" [value]="row.noSopralluogo"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noSopralluogo > 0 ? 'pointer': 'default'}"
                      (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'noSopralluogo')"
                      [pTooltip]="!isPresidioTIM && row.noSopralluogo > 0 ?'Apri le pratiche SENZA SOPRALLUOGO di ' + row.impresa:null" tooltipPosition="top"
                   
                      ></p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.noSopralluogoPF > 0" [value]="row.noSopralluogoPF"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noSopralluogoPF > 0 ? 'pointer': 'default'}"
                      (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'noSopralluogoPF')"
                      [pTooltip]=" !isPresidioTIM && row.noSopralluogoPF > 0 ? 'Apri le pratiche SENZA SOPRALLUOGO (PF) di ' + row.impresa: null" tooltipPosition="top"
             
                      ></p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.sopralluogoPianificato > 0" [value]="row.sopralluogoPianificato"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.sopralluogoPianificato > 0 ? 'pointer': 'default'}"
                      (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'sopralluogoPianificato')"
                  [pTooltip]=" !isPresidioTIM && row.sopralluogoPianificato > 0 ? 'Apri le pratiche CON SOPRALLUOGO PIANFICATO di ' + row.impresa: null" tooltipPosition="top"
             
                      ></p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.sopralluogoKO > 0" [value]="row.sopralluogoKO"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.sopralluogoKO > 0 ? 'pointer': 'default'}"
                      (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'sopralluogoKO')"
                 [pTooltip]=" !isPresidioTIM && row.sopralluogoKO > 0 ? 'Apri le pratiche CON SOPRALLUOGO KO di ' + row.impresa : null"
                 tooltipPosition="top"
                      ></p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.sopralluogoEseguito > 0" [value]="row.sopralluogoEseguito"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.sopralluogoEseguito > 0 ? 'pointer': 'default'}"
                      (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'sopralluogoEseguito')"
                [pTooltip]=" !isPresidioTIM && row.sopralluogoEseguito > 0 ? 'Apri le pratiche CON SOPRALLUOGO ESEGUITO di ' + row.impresa: null" tooltipPosition="top"
              
                      ></p-tag>
                  </td>
                 
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.totale > 0" [value]="row.totale"
                      [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A',
                      'padding': '.25em .5rem','font-weight': '700',
                      'font-size': '13px','letter-spacing': '.3px',
                      'cursor': 'pointer'
                          }"
                           (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                          tooltipPosition="top"></p-tag>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>
                  <td colspan="1" class="text-left" style="font-size: 12px; font-weight: bold;">TOTALI:</td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                    <p-tag [value]="totaliNoSopralluogoBando2"
                    [style]="{
                       'background-color': '#BFC0C0',
                       'color': '#191a1b',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '800',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                    }"
                     (click)="!isImpresa && openPraticheFase1(2,'noSopralluogo')"
                     [pTooltip]="'Apri TUTTE le pratiche SENZA SOPRALLUOGO'" 
                     tooltipPosition="top"
                    >
                </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                      <p-tag [value]="totaliNoSopralluogoPFBando2"
                        [style]="{
                            'background-color': '#7C90A0',
                            'color': '#191a1b',
                          'border-radius': '6px',
                          'padding': '.25em .5rem',
                          'font-weight': '800',
                          'font-size': '13px',
                          'letter-spacing': '.3px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                        }"
                        (click)="!isImpresa && openPraticheFase1(2,'noSopralluogoPF')"
                        [pTooltip]="'Apri TUTTE le pratiche SENZA SOPRALLUOGO (PF)'" 
                        tooltipPosition="top"                       
                        >
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                      <p-tag [value]="totaliSopralluogoPianificatoBando2"
                        [style]="{
                          'background-color': '#58A4B0',
                          'color': '#191a1b',
                          'border-radius': '6px',
                          'padding': '.25em .5rem',
                          'font-weight': '800',
                          'font-size': '13px',
                          'letter-spacing': '.3px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                        }"
                        (click)="!isImpresa && openPraticheFase1(2,'sopralluogoPianificato')"
                        [pTooltip]="'Apri TUTTE le pratiche CON SOPRALLUOGO PIANFICATO'" 
                        tooltipPosition="top"
                        >
                    </p-tag>
                    
                  </td>
                 
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                    <p-tag [value]="totaliSopralluogoKOBando2"
                      [style]="{
                         'background-color': '#F75C03',
                         'color': '#191a1b',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '800',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase1(2,'sopralluogoKO')"
                      [pTooltip]="'Apri TUTTE le pratiche CON SOPRALLUOGO KO'" 
                      tooltipPosition="top"
                      >
                  </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                    <p-tag [value]="totaliSopralluogoEseguitoBando2"
                      [style]="{
                        'background-color': '#04A777',
                        'color': '#191a1b',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '800',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase1(2,'sopralluogoEseguito')"
                      [pTooltip]="'Apri TUTTE le pratiche CON SOPRALLUOGO ESEGUITO'" 
                      tooltipPosition="top"
                      >
                  </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                    <p-tag [value]="totaliNoSopralluogoBando2 + totaliNoSopralluogoPFBando2 + totaliSopralluogoPianificatoBando2 + totaliSopralluogoEseguitoBando2 +totaliSopralluogoKOBando2"
                      [style]="{
                         'background-color': '#5f9ea0',
                         'color': '#191a1b',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '800',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                      }"
                      >
                  </p-tag>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>
        </p-tabView>
      </p-tabPanel>
  <p-tabPanel header="Appuntamenti / Attivazioni">
    <p-tabView [(activeIndex)]="activeBandoIndex" (onChange)="onBandoTabChange($event)">
      <p-tabPanel header="Bando 1">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <div>
            <p-dropdown
              styleClass="ml-2 fieldFilterControl"
              [options]="listeService.opzioniRegioneProntofibra"
              optionLabel="label"
              optionValue="value"
              (onChange)="filtraPerRegioneApp($event.value)"
              placeholder="Regione"
              [showClear]="false"
              [filter]="false"
              [(ngModel)]="filtroRegioneApp"
              [disabled]="isLoadingApp">
              <ng-template let-item pTemplate="item">
                <span class="font-['Poppins']" [style]="{
                  'background-color': '#85C7E7',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px',
                  'display': 'inline-block'
                }">{{ item.label | uppercase }}</span>
              </ng-template>
              <ng-template let-selectedItem pTemplate="selectedItem">
                <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                  'background-color': '#85C7E7',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px',
                  'display': 'inline-block'
                }">{{ selectedItem.label | uppercase }}</span>
              </ng-template>
            </p-dropdown>
            <p-dropdown
              styleClass="ml-2 fieldFilterControl"
              [options]="opzioniImpreseBando1App"
              optionLabel="label"
              optionValue="value"
              (onChange)="filtraPerImpresaApp($event.value)"
              placeholder="Impresa"
              [showClear]="false"
              [filter]="false"
              [(ngModel)]="filtroImpresaApp"
              [disabled]="isLoadingApp">
              <ng-template let-item pTemplate="item">
                <span class="font-['Poppins']" [style]="{
                  'background-color': '#5f9ea0',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px',
                  'display': 'inline-block'
                }">{{ item.label | uppercase }}</span>
              </ng-template>
              <ng-template let-selectedItem pTemplate="selectedItem">
                <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                  'background-color': '#5f9ea0',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px',
                  'display': 'inline-block'
                }">{{ selectedItem.label | uppercase }}</span>
              </ng-template>
            </p-dropdown>
            <p-dropdown 
              styleClass="ml-2 fieldFilterControl" 
              [options]="opzioniTipoSedeBando1App"
              optionLabel="label"
              optionValue="value"
              (onChange)="filtraPerTipoSedeEffettivaApp($event.value)"
              placeholder="Tipo Sede"
              [showClear]="false"
              [filter]="false"
              [(ngModel)]="filtroTipoSedeEffettivaApp"
              [disabled]="isLoadingApp">
              <ng-template let-item pTemplate="item">
                <span class="font-['Poppins']" [style]="{
                  'background-color': '#EBEBEB',
                  'color': '#191a1b',
                  'border': '1px solid #0A0A0A',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '600',
                  'font-size': '12px',
                  'letter-spacing': '.2px',
                  'display': 'inline-block'
                }">{{ item.label }}</span>
              </ng-template>
              <ng-template let-selectedItem pTemplate="selectedItem">
                <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                  'background-color': '#EBEBEB',
                  'color': '#191a1b',
                  'border': '1px solid #0A0A0A',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '600',
                  'font-size': '12px',
                  'letter-spacing': '.2px',
                  'display': 'inline-block'
                }">{{ selectedItem.label }}</span>
              </ng-template>
            </p-dropdown>
            <button *ngIf="filterIsSetApp" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
style="background-color: #607D8B; border-color: #455A64; color: #ffffff; font-size: 13px; min-height: 2.5rem; height: 2.5rem; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
              pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilterApp()"
            ></button>
          </div>
          <div class="p-2" style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: 0.25rem; height: 100%;">
            <ng-container *ngIf="!filterIsSetApp">
              <span class="font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">TUTTE LE REGIONI</span>
            </ng-container>
            <ng-container *ngIf="filterIsSetApp">
              <span *ngIf="filtroRegioneApp" class="font-['Poppins']" [style]="{'background-color': '#85C7E7', 'color': '#191a1b', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '700', 'font-size': '13px', 'letter-spacing': '.3px', 'display': 'inline-block', 'border': '1px solid #191a1b'}">{{ filtroRegioneApp | uppercase }}</span>
              <span *ngIf="filtroImpresaApp != null && filtroImpresaApp !== undefined" class="font-['Poppins']" [style]="{'background-color': '#5f9ea0', 'color': '#ffffff', 'border': '1px solid #191a1b', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '700', 'font-size': '13px', 'letter-spacing': '.3px', 'display': 'inline-block'}">{{ labelImpresaSelezionataApp | uppercase }}</span>
              <span *ngIf="filtroTipoSedeEffettivaApp" class="font-['Poppins']" [style]="{'background-color': '#EBEBEB', 'color': '#191a1b', 'border': '1px solid #0A0A0A', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '600', 'font-size': '12px', 'letter-spacing': '.2px', 'display': 'inline-block'}">{{ filtroTipoSedeEffettivaApp | uppercase }}</span>
            </ng-container>
          </div>
          <button 
            pButton type="button" icon="pi pi-cloud-download"
            pTooltip="Esporta i dati" tooltipPosition="top"
            class="font-['Poppins']"
            style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
            (click)="scaricaReportAppuntamenti()" 
          ></button>
        </div>
        <!-- Tabella Appuntamenti/Attivazioni Bando 1 -->
        <p-table styleClass="p-datatable-sm" 
          [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
          [paginator]="false" [loading]="isLoadingApp" [value]="datiRaggruppatiBando1AppFiltrati" 
          dataKey="impresa">
          <!-- HEADER -->
          <ng-template pTemplate="header">
            <tr>
              <th class="text-left font-['Poppins']" style="font-size: 11px; width: 20%; ">IMPRESA</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">MANCA PF<br>(NO NTW)</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">MANCA PF<br>(CON NTW)</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNT. DA PRENDERE<br>(PF PRONTO)</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNTAMENTO FISSATO</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNTAMENTO SCADUTO</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">ATTIVAZIONE KO</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">INSTALLAZIONE OK</th>   
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">ATTIVAZIONE OK</th>        
              <th class="text-center font-['Poppins'] font-bold" style="font-size: 11px;width: 10%;">TOTALE</th>
            </tr>
          </ng-template>
          <!-- BODY -->
          <ng-template pTemplate="body" let-row>
            <tr>
                <td>
                    <p-tag [value]="row.impresa | uppercase"
                      [style]="{
                        'background-color': '#5f9ea0',
                        'color': '#ffffff',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '700',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'cursor': 'pointer'
                      }"
                       (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                      tooltipPosition="top">
                    </p-tag>
                </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.noAppuntamentoMancaPF_noNTW > 0" [value]="row.noAppuntamentoMancaPF_noNTW"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noAppuntamentoMancaPF_noNTW > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa, 'noAppuntamentoMancaPF_noNTW')"
                  [pTooltip]="!isPresidioTIM && row.noAppuntamentoMancaPF_noNTW > 0 ?'Apri le pratiche SENZA PF e SENZA NTW di ' + row.impresa:null" tooltipPosition="top"
                
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.noAppuntamentoMancaPF_conNTW > 0" [value]="row.noAppuntamentoMancaPF_conNTW"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noAppuntamentoMancaPF_conNTW > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'noAppuntamentoMancaPF_conNTW')"
                  [pTooltip]="!isPresidioTIM && row.noAppuntamentoMancaPF_conNTW > 0 ? 'Apri le pratiche SENZA PF e CON NTW di ' + row.impresa: null" tooltipPosition="top"
             
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.noAppuntamentoPFPronto > 0" [value]="row.noAppuntamentoPFPronto"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noAppuntamentoPFPronto > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'noAppuntamentoPFPronto')"
                  [pTooltip]="!isPresidioTIM && row.noAppuntamentoPFPronto > 0 ? 'Apri le pratiche SENZA APPUNTAMENTO E CON PF PRONTO di ' + row.impresa: null" tooltipPosition="top"
                
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.appuntamentoFissato > 0" [value]="row.appuntamentoFissato"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.appuntamentoFissato > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'appuntamentoFissato')"
                  [pTooltip]="!isPresidioTIM && row.appuntamentoFissato > 0 ? 'Apri le pratiche CON APPUNTAMENTO PIANFICATO di ' + row.impresa: null" tooltipPosition="top"
                 
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.appuntamentoScaduto > 0" [value]="row.appuntamentoScaduto"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.appuntamentoScaduto > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'appuntamentoScaduto')"
                  [pTooltip]="!isPresidioTIM && row.appuntamentoScaduto > 0 ? 'Apri le pratiche CON APPUNTAMENTO SCADUTO di ' + row.impresa: null" tooltipPosition="top"
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.attivazioneKO > 0" [value]="row.attivazioneKO"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.attivazioneKO > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'attivazioneKO')"
                  [pTooltip]="!isPresidioTIM && row.attivazioneKO > 0 ? 'Apri le pratiche CON ATTIVAZIONE KO di ' + row.impresa: null" tooltipPosition="top"
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.installazioneOK > 0" [value]="row.installazioneOK"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.installazioneOK > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'installazioneOK')"
                  [pTooltip]="!isPresidioTIM && row.installazioneOK > 0 ? 'Apri le pratiche CON INSTALLAZIONE OK di ' + row.impresa: null" tooltipPosition="top"
                ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.attivazioneOK > 0" [value]="row.attivazioneOK"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.attivazioneOK > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'attivazioneOK')"
                  [pTooltip]="!isPresidioTIM && row.attivazioneOK > 0 ? 'Apri le pratiche CON ATTIVAZIONE OK di ' + row.impresa: null" tooltipPosition="top"
                ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.totale > 0" [value]="row.totale"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem',
                  'font-weight': '700','font-size': '13px','letter-spacing': '.3px',
                  'cursor': 'pointer'
                      }"
                       (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                      tooltipPosition="top"></p-tag>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td colspan="1" class="text-left" style="font-size: 12px; font-weight: bold;">TOTALI:</td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando1NoAppuntamentoMancaPF_noNTW"
                  [style]="{
                    'background-color': '#C0C5C1',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(1,'noAppuntamentoMancaPF_noNTW')"
                  [pTooltip]="!isImpresa && totaliAppBando1NoAppuntamentoMancaPF_noNTW > 0 ? 'Apri TUTTE le pratiche SENZA PF e SENZA NTW' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando1NoAppuntamentoMancaPF_conNTW"
                  [style]="{
                    'background-color': '#7D8491',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(1,'noAppuntamentoMancaPF_conNTW')"
                  [pTooltip]="!isImpresa && totaliAppBando1NoAppuntamentoMancaPF_conNTW > 0 ? 'Apri TUTTE le pratiche SENZA PF e CON NTW' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
             
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando1NoAppuntamentoPFPronto"
                  [style]="{
                    'background-color': '#BAE1FF',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(1,'noAppuntamentoPFPronto')"
                  [pTooltip]="!isImpresa && totaliAppBando1NoAppuntamentoPFPronto > 0 ? 'Apri TUTTE le pratiche SENZA PF e CON PF PRONTO' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando1AppuntamentoFissato"
                  [style]="{
                    'background-color': '#EAF0CE',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(1,'appuntamentoFissato')"
                  [pTooltip]="!isImpresa && totaliAppBando1AppuntamentoFissato > 0 ? 'Apri TUTTE le pratiche CON APPUNTAMENTO PIANFICATO' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando1AppuntamentoScaduto"
                  [style]="{
                    'background-color': '#6C809A',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(1,'appuntamentoScaduto')"
                  [pTooltip]="!isImpresa && totaliAppBando1AppuntamentoScaduto > 0 ? 'Apri TUTTE le pratiche CON APPUNTAMENTO SCADUTO' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando1AttivazioneKO"
                  [style]="{
                    'background-color': '#DA626C',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(1,'attivazioneKO')"
                  [pTooltip]="!isImpresa && totaliAppBando1AttivazioneKO > 0 ? 'Apri TUTTE le pratiche CON ATTIVAZIONE KO' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando1installazioneOK"
                  [style]="{
                    'background-color': '#36827F',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(1,'installazioneOK')"
                  [pTooltip]="!isImpresa && totaliAppBando1installazioneOK > 0 ? 'Apri TUTTE le pratiche CON INSTALLAZIONE OK' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando1AttivazioneOK"
                  [style]="{
                    'background-color': '#B1D385',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(1,'attivazioneOK')"
                  [pTooltip]="!isImpresa && totaliAppBando1AttivazioneOK > 0 ? 'Apri TUTTE le pratiche CON ATTIVAZIONE OK' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
             
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando1"
                  [style]="{
                    'background-color': '#5f9ea0',
                    'color': '#191a1b',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                  }"
                  >
                </p-tag>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Bando 2">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <div>
            <p-dropdown
              styleClass="ml-2 fieldFilterControl"
              [options]="listeService.opzioniRegioneProntofibra"
              optionLabel="label"
              optionValue="value"
              (onChange)="filtraPerRegioneApp($event.value)"
              placeholder="Regione"
              [showClear]="false"
              [filter]="false"
              [(ngModel)]="filtroRegioneApp"
              [disabled]="isLoadingApp">
              <ng-template let-item pTemplate="item">
                <span class="font-['Poppins']" [style]="{
                  'background-color': '#85C7E7',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px',
                  'display': 'inline-block'
                }">{{ item.label | uppercase }}</span>
              </ng-template>
              <ng-template let-selectedItem pTemplate="selectedItem">
                <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                  'background-color': '#85C7E7',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px',
                  'display': 'inline-block'
                }">{{ selectedItem.label | uppercase }}</span>
              </ng-template>
            </p-dropdown>
            <p-dropdown
              styleClass="ml-2 fieldFilterControl"
              [options]="opzioniImpreseBando2App"
              optionLabel="label"
              optionValue="value"
              (onChange)="filtraPerImpresaApp($event.value)"
              placeholder="Impresa"
              [showClear]="false"
              [filter]="false"
              [(ngModel)]="filtroImpresaApp"
              [disabled]="isLoadingApp">
              <ng-template let-item pTemplate="item">
                <span class="font-['Poppins']" [style]="{
                  'background-color': '#5f9ea0',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px',
                  'display': 'inline-block'
                }">{{ item.label | uppercase }}</span>
              </ng-template>
              <ng-template let-selectedItem pTemplate="selectedItem">
                <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                  'background-color': '#5f9ea0',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px',
                  'display': 'inline-block'
                }">{{ selectedItem.label | uppercase }}</span>
              </ng-template>
            </p-dropdown>
            <p-dropdown 
              styleClass="ml-2 fieldFilterControl" 
              [options]="opzioniTipoSedeBando2App"
              optionLabel="label"
              optionValue="value"
              (onChange)="filtraPerTipoSedeEffettivaApp($event.value)"
              placeholder="Tipo Sede"
              [showClear]="false"
              [filter]="false"
              [(ngModel)]="filtroTipoSedeEffettivaApp"
              [disabled]="isLoadingApp">
              <ng-template let-item pTemplate="item">
                <span class="font-['Poppins']" [style]="{
                  'background-color': '#EBEBEB',
                  'color': '#191a1b',
                  'border': '1px solid #0A0A0A',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '600',
                  'font-size': '12px',
                  'letter-spacing': '.2px',
                  'display': 'inline-block'
                }">{{ item.label }}</span>
              </ng-template>
              <ng-template let-selectedItem pTemplate="selectedItem">
                <span *ngIf="selectedItem" class="font-['Poppins']" [style]="{
                  'background-color': '#EBEBEB',
                  'color': '#191a1b',
                  'border': '1px solid #0A0A0A',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '600',
                  'font-size': '12px',
                  'letter-spacing': '.2px',
                  'display': 'inline-block'
                }">{{ selectedItem.label }}</span>
              </ng-template>
            </p-dropdown>
            <button *ngIf="filterIsSetApp" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
style="background-color: #607D8B; border-color: #455A64; color: #ffffff; font-size: 13px; min-height: 2.5rem; height: 2.5rem; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
              pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilterApp()"
            ></button>
          </div>
          <div class="p-2" style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: 0.25rem; height: 100%;">
            <ng-container *ngIf="!filterIsSetApp">
              <span class="font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">TUTTE LE REGIONI</span>
            </ng-container>
            <ng-container *ngIf="filterIsSetApp">
              <span *ngIf="filtroRegioneApp" class="font-['Poppins']" [style]="{'background-color': '#85C7E7', 'color': '#191a1b', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '700', 'font-size': '13px', 'letter-spacing': '.3px', 'display': 'inline-block', 'border': '1px solid #191a1b'}">{{ filtroRegioneApp | uppercase }}</span>
              <span *ngIf="filtroImpresaApp != null && filtroImpresaApp !== undefined" class="font-['Poppins']" [style]="{'background-color': '#5f9ea0', 'color': '#ffffff', 'border': '1px solid #191a1b', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '700', 'font-size': '13px', 'letter-spacing': '.3px', 'display': 'inline-block'}">{{ labelImpresaSelezionataApp | uppercase }}</span>
              <span *ngIf="filtroTipoSedeEffettivaApp" class="font-['Poppins']" [style]="{'background-color': '#EBEBEB', 'color': '#191a1b', 'border': '1px solid #0A0A0A', 'border-radius': '6px', 'padding': '.25em .5rem', 'font-weight': '600', 'font-size': '12px', 'letter-spacing': '.2px', 'display': 'inline-block'}">{{ filtroTipoSedeEffettivaApp | uppercase }}</span>
            </ng-container>
          </div>
          <button 
            pButton type="button" icon="pi pi-cloud-download"
            pTooltip="Esporta i dati" tooltipPosition="top"
            class="font-['Poppins']"
            style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
            (click)="scaricaReportAppuntamenti()" 
          ></button>
        </div>
        <!-- Tabella Appuntamenti/Attivazioni Bando 2 -->
        <p-table styleClass="p-datatable-sm" 
          [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
          [paginator]="false" [loading]="isLoadingApp" [value]="datiRaggruppatiBando2AppFiltrati" dataKey="impresa">
          <!-- HEADER -->
          <ng-template pTemplate="header">
            <tr>
              <th class="text-left font-['Poppins']" style="font-size: 11px; width: 20%; ">IMPRESA</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">MANCA PF<br>(NO NTW)</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">MANCA PF<br>(CON NTW)</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNT. DA PRENDERE<br>(PF PRONTO)</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNTAMENTO FISSATO</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNTAMENTO SCADUTO</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">ATTIVAZIONE KO</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">INSTALLAZIONE OK</th>   
              <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">ATTIVAZIONE OK</th>        
              <th class="text-center font-['Poppins'] font-bold" style="font-size: 11px;width: 10%;">TOTALE</th>
            </tr>
          </ng-template>
          <!-- BODY -->
          <ng-template pTemplate="body" let-row>
            <tr>
                <td>
                    <p-tag [value]="row.impresa | uppercase"
                      [style]="{
                        'background-color': '#5f9ea0',
                        'color': '#ffffff',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '700',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'cursor': 'pointer'
                      }"
                       (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                      tooltipPosition="top">
                    </p-tag>
                </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.noAppuntamentoMancaPF_noNTW > 0" [value]="row.noAppuntamentoMancaPF_noNTW"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noAppuntamentoMancaPF_noNTW > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa, 'noAppuntamentoMancaPF_noNTW')"
               [pTooltip]="!isPresidioTIM && row.noAppuntamentoMancaPF_noNTW > 0 ?'Apri le pratiche SENZA PF e SENZA NTW di ' + row.impresa:null" tooltipPosition="top"
             
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.noAppuntamentoMancaPF_conNTW > 0" [value]="row.noAppuntamentoMancaPF_conNTW"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noAppuntamentoMancaPF_conNTW > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'noAppuntamentoMancaPF_conNTW')"
                  [pTooltip]="!isPresidioTIM && row.noAppuntamentoMancaPF_conNTW > 0 ? 'Apri le pratiche SENZA PF e CON NTW di ' + row.impresa: null" tooltipPosition="top"
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.noAppuntamentoPFPronto > 0" [value]="row.noAppuntamentoPFPronto"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.noAppuntamentoPFPronto > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'noAppuntamentoPFPronto')"
                  [pTooltip]="!isPresidioTIM && row.noAppuntamentoPFPronto > 0 ? 'Apri le pratiche SENZA APPUNTAMENTO E CON PF PRONTO di ' + row.impresa: null" tooltipPosition="top"
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.appuntamentoFissato > 0" [value]="row.appuntamentoFissato"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.appuntamentoFissato > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'appuntamentoFissato')"
                  [pTooltip]="!isPresidioTIM && row.appuntamentoFissato > 0 ? 'Apri le pratiche CON APPUNTAMENTO PIANFICATO di ' + row.impresa: null" tooltipPosition="top"
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.appuntamentoScaduto > 0" [value]="row.appuntamentoScaduto"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.appuntamentoScaduto > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'appuntamentoScaduto')"
                  [pTooltip]="!isPresidioTIM && row.appuntamentoScaduto > 0 ? 'Apri le pratiche CON APPUNTAMENTO SCADUTO di ' + row.impresa: null" tooltipPosition="top"
                ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.attivazioneKO > 0"    [value]="row.attivazioneKO"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.attivazioneKO > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'attivazioneKO')"
                  [pTooltip]="!isPresidioTIM && row.attivazioneKO > 0 ? 'Apri le pratiche CON ATTIVAZIONE KO di ' + row.impresa: null" tooltipPosition="top"
                ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.installazioneOK > 0" [value]="row.installazioneOK"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.installazioneOK > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'installazioneOK')"
                  [pTooltip]="!isPresidioTIM && row.installazioneOK > 0 ? 'Apri le pratiche CON INSTALLAZIONE OK di ' + row.impresa: null" tooltipPosition="top"
                ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.attivazioneOK > 0" [value]="row.attivazioneOK"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A','padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px','cursor': row.attivazioneOK > 0 ? 'pointer': 'default'}"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'attivazioneOK')"
                  [pTooltip]="!isPresidioTIM && row.attivazioneOK > 0 ? 'Apri le pratiche CON ATTIVAZIONE OK di ' + row.impresa: null" tooltipPosition="top"
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.totale > 0" [value]="row.totale"
                  [style]="{'background-color': '#EBEBEB','color': '#000000','border-radius': '6px','border-color':'#0A0A0A',
                  'padding': '.25em .5rem','font-weight': '700','font-size': '13px','letter-spacing': '.3px',
                  'cursor': 'pointer'
                      }"
                       (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                      tooltipPosition="top">
                </p-tag>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td colspan="1" class="text-left" style="font-size: 12px; font-weight: bold;">TOTALI:</td>
             
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando2NoAppuntamentoMancaPF_noNTW"
                  [style]="{
                    'background-color': '#C0C5C1',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(2,'noAppuntamentoMancaPF_noNTW')"
                  [pTooltip]="!isImpresa && totaliAppBando2NoAppuntamentoMancaPF_noNTW > 0 ? 'Apri TUTTE le pratiche SENZA PF e SENZA NTW' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando2NoAppuntamentoMancaPF_conNTW"
                  [style]="{
                    'background-color': '#7D8491',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(2,'noAppuntamentoMancaPF_conNTW')"
                  [pTooltip]="!isImpresa && totaliAppBando2NoAppuntamentoMancaPF_conNTW > 0 ? 'Apri TUTTE le pratiche SENZA PF e CON NTW' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando2NoAppuntamentoPFPronto"
                  [style]="{
                    'background-color': '#BAE1FF',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(2,'noAppuntamentoPFPronto')"
                  [pTooltip]="!isImpresa && totaliAppBando2NoAppuntamentoPFPronto > 0 ? 'Apri TUTTE le pratiche SENZA PF e CON PF PRONTO' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando2AppuntamentoFissato"
                  [style]="{
                    'background-color': '#EAF0CE',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(2,'appuntamentoFissato')"
                  [pTooltip]="!isImpresa && totaliAppBando2AppuntamentoFissato > 0 ? 'Apri TUTTE le pratiche CON APPUNTAMENTO PIANFICATO' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando2AppuntamentoScaduto"
                  [style]="{
                    'background-color': '#6C809A',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(2,'appuntamentoScaduto')"
                  [pTooltip]="!isImpresa && totaliAppBando2AppuntamentoScaduto > 0 ? 'Apri TUTTE le pratiche CON APPUNTAMENTO SCADUTO' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando2AttivazioneKO"
                  [style]="{
                    'background-color': '#DA626C',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(2,'attivazioneKO')"
                  [pTooltip]="!isImpresa && totaliAppBando2AttivazioneKO > 0 ? 'Apri TUTTE le pratiche CON ATTIVAZIONE KO' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
             
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando2installazioneOK"
                  [style]="{
                    'background-color': '#36827F',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(2,'installazioneOK')"
                  [pTooltip]="!isImpresa && totaliAppBando2installazioneOK > 0 ? 'Apri TUTTE le pratiche CON INSTALLAZIONE OK' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando2AttivazioneOK"
                  [style]="{
                    'background-color': '#B1D385',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                  }"
                  (click)="!isImpresa && openPraticheFase2(2,'attivazioneOK')"
                  [pTooltip]="!isImpresa && totaliAppBando2AttivazioneOK > 0 ? 'Apri TUTTE le pratiche CON ATTIVAZIONE OK' : null"
                  tooltipPosition="top"
                >
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag
                  [value]="totaliAppBando2"
                  [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                  }"
                  >
                </p-tag>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
    </p-tabView>
  </p-tabPanel>
  <p-tabPanel header="Stato Open Fiber">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
      <div style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: nowrap;">
        <p-multiSelect 
          styleClass="fieldFilterControl" 
          [options]="listeService.opzioniRegioneProntofibra"
          [showToggleAll]="false"
          optionLabel="label"
          optionValue="value"
          (onChange)="filtraPerRegioneOF($event.value)"
          placeholder="Regione"
          [showClear]="false"
          [filter]="false"
          [showHeader]="false"
          [(ngModel)]="filtroRegioneOF"
          [style]="{'min-height': '2.5rem', 'font-size': '14px'}"
        />
        <p-dropdown 
          styleClass="fieldFilterControl" 
          [options]="opzioniCategoriaVincoloOF"
          optionLabel="label"
          optionValue="value"
          (onChange)="filtraPerCategoriaVincoloOF($event.value)"
          placeholder="Servizio OF"
          [showClear]="false"
          [filter]="false"
          [(ngModel)]="filtroCategoriaVincoloOF"
          [style]="{'min-height': '2.5rem', 'font-size': '14px'}"
        >
          <ng-template let-option pTemplate="item">
            <div class="flex align-items-center">
              <p-tag
                [value]="option.label | uppercase"
                [style]="getStileServizioOF(option.value)"
                class="mr-1"
              ></p-tag>
            </div>
          </ng-template>
        </p-dropdown>
        <button *ngIf="filterIsSetOF" pButton type="button" icon="pi pi-filter-slash"
style="background-color: #607D8B; border-color: #455A64; color: #ffffff; font-size: 13px; min-height: 2.5rem; height: 2.5rem; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
          pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilterOF()"
        ></button>
      </div>
      <div style="display: flex; align-items: center; gap: 0.75rem;">
        <div class="p-2" style="border-radius: 10px; background-color: #85C7E7; display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; padding: 0.5rem;">
          <span class="text-right font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">{{labelRegioniOF}}</span>
          <span class="text-right font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">{{labelCategoriaVincoloOF}}</span>
        </div>
        
        <!-- Badge totale pratiche -->
        <div class="flex align-items-center" 
             style="padding: 0.4rem 0.75rem; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 8px; box-shadow: 0 2px 6px rgba(102, 126, 234, 0.25); height: fit-content;">
          <i class="pi pi-list" style="font-size: 0.9rem; color: #ffffff; margin-right: 0.4rem;"></i>
          <span class="font-['Poppins']" style="font-size: 11px; font-weight: 600; color: #ffffff; letter-spacing: 0.2px; white-space: nowrap; margin-right: 0.4rem;">
            {{hasActiveCommonFiltersOF ? 'Filtrate:' : 'Totali:'}}
          </span>
          <p-tag 
            [value]="(hasActiveCommonFiltersOF ? totalePraticheFiltrateOF : totalePraticheOF).toString()" 
            [style]="{
              'background-color': '#ffffff',
              'color': '#667eea',
              'border-radius': '16px',
              'padding': '.2em .6rem',
              'font-weight': '700',
              'font-size': '11px',
              'letter-spacing': '.2px',
              'min-width': '32px',
              'text-align': 'center'
            }"
          ></p-tag>
        </div>
      </div>
      <div style="display: flex; align-items: center; gap: 0.5rem;">
        <button
          pButton type="button" icon="pi pi-file-import"
          pTooltip="Aggiorna Situazione OF" tooltipPosition="top"
          class="font-['Poppins']"
          style="background-color:#ffffff; color: #270a66; border-color: #270a66; font-size: 13px;"
          (click)="aggiornaSituazioneOF()" [disabled]="isLoadingApp"
        ></button>
        <button 
          pButton type="button" icon="pi pi-cloud-download"
          pTooltip="Esporta i dati" tooltipPosition="top"
          class="font-['Poppins']"
          style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
          (click)="scaricaReportVincoliOF()" 
        ></button>
      </div>
    </div>
    <p-tabView [(activeIndex)]="activeOFIndex">
      <p-tabPanel header="Complessivo">
        <p-table styleClass="p-datatable-sm vincoli-of-table" 
          [selectionPageOnly]="true" [rowHover]="true" 
          [paginator]="false" [loading]="isLoadingApp" 
          [value]="vincoliOFData" 
          dataKey="categoria">
          <ng-template pTemplate="header">
            <tr>
              <th rowspan="2" class="text-left" style="font-size: 12px; font-weight: 600; width: 25%;">STATO OPEN FIBER</th>
              <th colspan="4" class="text-center" style="font-size: 12px; font-weight: 700; background: #f8f9fa; color: #2c3e50; border-bottom: 2px solid #dee2e6;">LOTTO</th>
              <th colspan="3" class="text-center" style="font-size: 12px; font-weight: 700; background: #f8f9fa; color: #2c3e50; border-bottom: 2px solid #dee2e6; border-left: 2px solid #7BA7D1;  ">SERVIZIO OF</th>
              <th colspan="3" class="text-center" style="font-size: 12px; font-weight: 700; background: #f8f9fa; color: #2c3e50; border-bottom: 2px solid #dee2e6;border-left: 2px solid #81C784;">STATO PF</th>
              <th rowspan="2" class="text-center" style="font-size: 11px; font-weight: 700; width: 13%; background: #e9ecef; border-left: 2px solid #000000;">TOTALI</th>
            </tr>
            <tr>
              <th class="text-center" style="font-size: 11px; font-weight: 600; width: 7%;">1</th>
              <th class="text-center" style="font-size: 11px; font-weight: 600; width: 7%;">5</th>
              <th class="text-center" style="font-size: 11px; font-weight: 600; width: 7%;">7</th>
              <th class="text-center" style="font-size: 11px; font-weight: 600; width: 7%;">8</th>
              <th class="text-center" style="font-size: 11px; font-weight: 700; width: 9%; background: #B8D4F0; color: #2c3e50; border-left: 2px solid #7BA7D1;">ATTIVO</th>
              <th class="text-center" style="font-size: 11px; font-weight: 700; width: 9%; background: #FFD4B3; color: #2c3e50; border-left: 1px solid #FFB380;">PASSIVO</th>
              <th class="text-center" style="font-size: 11px; font-weight: 700; width: 9%; background: #E0E0E0; color: #2c3e50; border-left: 1px solid #BDBDBD;">SENZA SERVIZIO</th>
              <th class="text-center" style="font-size: 11px; font-weight: 700; width: 10%; background: #D6D6D6; color: #2c3e50; border-left: 2px solid #81C784;">IN ATTESA</th>
              <th class="text-center" style="font-size: 11px; font-weight: 700; width: 8%; background: #C8E6C9; color: #2c3e50; border-left: 1px solid #81C784;">ATTIVATE</th>
              <th class="text-center" style="font-size: 11px; font-weight: 700; width: 8%; background: #FFE0B2; color: #2c3e50; border-left: 1px solid #FFB74D;">RILASCIATE FIBERCOP</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [ngClass]="{'highlighted-row': isRowHighlighted(row.categoria)}" 
                [style.background-color]="row.categoria === 'NON CATEGORIZZATE' ? '#ffebee' : (row.categoria === 'ESPLETATE' ? '#d4edda' : (row.categoria === 'VINCOLO FIBERCOP' || row.categoria === 'VINCOLO INFRATEL' || row.categoria === 'FUORI PERIMETRO') ? '#f5f5f5' : (isRowHighlighted(row.categoria) ? '#fff3cd' : ''))"
                [style.border-left]="row.categoria === 'NON CATEGORIZZATE' ? '4px solid #dc3545' : (isRowHighlighted(row.categoria) ? '4px solid #ffc107' : (row.categoria === 'ESPLETATE' ? '4px solid #28a745' : ''))"
                [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : (row.categoria === 'NON CATEGORIZZATE' ? '2px solid #dc3545' : '')"
                [style.font-weight]="row.categoria === 'NON CATEGORIZZATE' ? '700' : (row.categoria === 'ESPLETATE' ? '700' : (isRowHighlighted(row.categoria) ? '700' : '500'))"
                [style.font-style]="(row.categoria === 'VINCOLO FIBERCOP' || row.categoria === 'VINCOLO INFRATEL' || row.categoria === 'FUORI PERIMETRO') ? 'italic' : 'normal'"
                [style.color]="row.categoria === 'NON CATEGORIZZATE' ? '#dc3545' : ''">
              <td class="text-left" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '500'" [style.font-style]="(row.categoria === 'VINCOLO FIBERCOP' || row.categoria === 'VINCOLO INFRATEL' || row.categoria === 'FUORI PERIMETRO') ? 'italic' : 'normal'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 10px;">{{row.categoria}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '400'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px;">{{row.lotto1}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '400'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px;">{{row.lotto5}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '400'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px;">{{row.lotto7}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '400'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px;">{{row.lotto8}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '600'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px; background: #B8D4F0; color: #2c3e50; border-left: 2px solid #7BA7D1;">{{row.attivo}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '600'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px; background: #FFD4B3; color: #2c3e50; border-left: 1px solid #FFB380;">{{row.passivo}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '600'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px; background: #E0E0E0; color: #2c3e50; border-left: 1px solid #BDBDBD;">{{row.senzaServizio}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '600'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px; background: #D6D6D6; color: #2c3e50; border-left: 2px solid #81C784;">{{row.inAttesa}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '600'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px; background: #C8E6C9; color: #2c3e50; border-left: 1px solid #81C784;">{{row.attivate}}</td>
              <td class="text-center" [style.font-weight]="row.categoria === 'ESPLETATE' ? '700' : '600'" [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : ''" style="font-size: 11px; background: #FFE0B2; color: #2c3e50; border-left: 1px solid #FFB74D;">{{row.rilasciateFibercop}}</td>
              <td class="text-center" 
                  [style.background-color]="row.categoria === 'NON CATEGORIZZATE' ? '#ffcdd2' : (row.categoria === 'ESPLETATE' ? '#d4edda' : (isRowHighlighted(row.categoria) ? '#ffe69c' : '#f8f9fa'))" 
                  [style.font-weight]="row.categoria === 'ESPLETATE' || row.categoria === 'NON CATEGORIZZATE' ? '700' : '700'" 
                  [style.border-top]="row.categoria === 'VINCOLO FIBERCOP' ? '2px solid #000000' : (row.categoria === 'NON CATEGORIZZATE' ? '2px solid #dc3545' : '')" 
                  [style.color]="row.categoria === 'NON CATEGORIZZATE' ? '#dc3545' : ''" 
                  [style.cursor]="'pointer'"
                  [pTooltip]="'Clicca per vedere le pratiche filtrate'"
                  tooltipPosition="top"
                  (click)="filtraPerCategoriaEMostraPratiche(row.categoria)"
                  style="font-size: 11px; border-left: 2px solid #000000;">{{row.totale}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td class="text-left" style="font-size: 11px; font-weight: 700; background: #e9ecef; padding: 0.75rem 0.5rem; border-top: 1px solid #000000;">TOTALI</td>
              <td class="text-center" style="font-size: 12px; font-weight: 700; background: #e9ecef; padding: 0.75rem 0.5rem; border-top: 1px solid #000000;">{{totaliLotto1}}</td>
              <td class="text-center" style="font-size: 12px; font-weight: 700; background: #e9ecef; padding: 0.75rem 0.5rem; border-top: 1px solid #000000;">{{totaliLotto5}}</td>
              <td class="text-center" style="font-size: 12px; font-weight: 700; background: #e9ecef; padding: 0.75rem 0.5rem; border-top: 1px solid #000000;">{{totaliLotto7}}</td>
              <td class="text-center" style="font-size: 12px; font-weight: 700; background: #e9ecef; padding: 0.75rem 0.5rem; border-top: 1px solid #000000;">{{totaliLotto8}}</td>
              <td class="text-center" style="font-size: 13px; font-weight: 800; background: #B8D4F0; color: #2c3e50; padding: 0.75rem 0.5rem; border-left: 2px solid #7BA7D1; border-top: 1px solid #000000;">{{totaleAttivo}}</td>
              <td class="text-center" style="font-size: 13px; font-weight: 800; background: #FFD4B3; color: #2c3e50; padding: 0.75rem 0.5rem; border-left: 1px solid #FFB380; border-top: 1px solid #000000;  ">{{totalePassivo}}</td>
              <td class="text-center" style="font-size: 13px; font-weight: 800; background: #E0E0E0; color: #2c3e50; padding: 0.75rem 0.5rem; border-left: 1px solid #BDBDBD; border-top: 1px solid #000000;">{{totaleSenzaServizio}}</td>
              <td class="text-center" style="font-size: 13px; font-weight: 800; background: #D6D6D6; color: #2c3e50; padding: 0.75rem 0.5rem; border-left: 2px solid #81C784; border-top: 1px solid #000000;">{{totaleInAttesa}}</td>
              <td class="text-center" style="font-size: 13px; font-weight: 800; background: #C8E6C9; color: #2c3e50; padding: 0.75rem 0.5rem; border-left: 1px solid #81C784; border-top: 1px solid #000000;">{{totaleAttivate}}</td> 
              <td class="text-center" style="font-size: 13px; font-weight: 800; background: #FFE0B2; color: #2c3e50; padding: 0.75rem 0.5rem; border-left: 1px solid #FFB74D; border-top: 1px solid #000000;">{{totaleRilasciateFibercop}}</td>
              <td class="text-center" style="font-size: 13px; font-weight: 800; background: #495057; color: #ffffff; padding: 0.75rem 0.5rem; border-left: 1px solid #000000; border-top: 1px solid #000000;">{{totaleComplessivo}}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="Pratiche">
        <div class="mb-3" style="display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap;">
          <div class="flex align-items-center gap-2" style="flex: 1;">
            <p-dropdown 
              styleClass="fieldFilterControl" 
              [options]="opzioniStatoOF"
              optionLabel="label"
              optionValue="value"
              (onChange)="filtraPerStatoOF($event.value)"
              placeholder="Stato OF"
              [showClear]="true"
              [filter]="false"
              [(ngModel)]="filtroStatoOF"
              [style]="{'min-height': '2.5rem', 'font-size': '14px', 'min-width': '280px'}"
            >
              <ng-template let-option pTemplate="item">
                <div class="flex align-items-center">
                  <p-tag
                    [value]="option.label | uppercase"
                    [style]="getStileStatoOFFilter(option.value)"
                    class="mr-1"  
                  ></p-tag>
                </div>
              </ng-template>
            </p-dropdown>
            <input 
              pInputText 
              type="text" 
              placeholder="Cerca per CUI"
              [(ngModel)]="filtroCuiOF"
              (ngModelChange)="filtraPerCuiOF($event)"
              styleClass="fieldFilterControl"
              style="width: 200px; min-height: 2.5rem; font-size: 14px;"
            />
          </div>
          
          <!-- Indicatore totale pratiche filtrate -->
          <div *ngIf="hasActiveFiltersOF" class="flex align-items-center" 
               style="padding: 0.5rem 1rem; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 8px; box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3); height: fit-content;">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-filter" style="font-size: 1rem; color: #ffffff;"></i>
              <span class="font-['Poppins']" style="font-size: 12px; font-weight: 600; color: #ffffff; letter-spacing: 0.3px; white-space: nowrap;">
                Pratiche filtrate:
              </span>
              <p-tag 
                [value]="totalePraticheFiltrateOF.toString()" 
                [style]="{
                  'background-color': '#ffffff',
                  'color': '#667eea',
                  'border-radius': '20px',
                  'padding': '.25em .75rem',
                  'font-weight': '700',
                  'font-size': '12px',
                  'letter-spacing': '.3px'
                }"
              ></p-tag>
            </div>
          </div>
          
          <!-- <div class="flex align-items-center" style="gap: 0.5rem; white-space: nowrap;">
            <p-checkbox 
              [(ngModel)]="filtroVendibile"
              (onChange)="updatePraticheTipoCFiltrate()"
              [binary]="true"
              inputId="filtroVendibile"
            ></p-checkbox>
            <label for="filtroVendibile" class="font-['Poppins']" style="font-size: 13px; font-weight: 500; cursor: pointer; user-select: none; margin: 0;">
              Solo ESPLETATE
            </label>
          </div> -->
        </div>
        
        <p-table #tablePraticheOF styleClass="p-datatable-sm" 
          [selectionPageOnly]="true" [rowHover]="true" 
          [rows]="20" [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[20,50,100]" [loading]="isLoadingApp" 
          [value]="praticheTipoCFiltrate" 
          dataKey="id" 
          [paginator]="true"
          currentPageReportTemplate="{first} - {last} di {totalRecords}">
          <ng-template pTemplate="header">
            <tr>
              <th class="font-['Poppins']" style="font-size: 10px; width: 15%; font-weight: 700; color: #2c3e50;">CUI</th>
              <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">Lotto</th>
              <th class="font-['Poppins']" style="font-size: 10px; width: 8%;">Regione</th>
              <th class="font-['Poppins']" style="font-size: 10px; width: 7%;">Provincia</th>
              <th class="font-['Poppins']" style="font-size: 10px; width: 8%;">Comune</th>
              <th class="font-['Poppins']" style="font-size: 10px; width: 18%;">Denominazione</th>
              <th class="text-center font-['Poppins']" style="font-size: 9px; width: 6%;">Tipologia Sede</th>
              <th *ngIf="!isImpresa" class="text-center font-['Poppins']" style="font-size: 10px; width: 10%;">Impresa</th>
              <th class="text-center font-['Poppins']" style="font-size: 10px; width: 11%;">VINCOLO</th>
              <th class="text-center font-['Poppins']" style="font-size: 11px; width: 10%; font-weight: 600;">SERVIZIO OF</th>
              <th class="text-center font-['Poppins']" style="font-size: 12px; width: 22%; font-weight: 700; background: #e9ecef; padding: 0.75rem 0.5rem;">STATO OPEN FIBER</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td class="text-left font-['Poppins']" style="font-size: 10px; font-weight: 700; color: #2c3e50; letter-spacing: 0.5px;">{{row.cui}}</td>
              <td class="text-center font-['Poppins']" style="font-size: 10px;">
                <p-tag [value]="row.lotto | uppercase"
                  [style]="{
                    'background-color': '#EBC66B',
                    'color': '#ffffff',
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '700',
                    'font-size': '9px',
                    'letter-spacing': '.3px'
                  }"
                  class="mr-1"
                ></p-tag>
              </td>
              <td class="text-left font-['Poppins']" style="font-size: 10px;">{{row.regione}}</td>
              <td class="text-left font-['Poppins']" style="font-size: 10px;">{{row.provincia || '-'}}</td>
              <td class="text-left font-['Poppins']" style="font-size: 10px;">{{row.comune}}</td>
              <td class="text-left font-['Poppins']" style="font-size: 10px;">{{row.denominazione}}</td>
              <td class="text-center font-['Poppins']" style="font-size: 8px; white-space: nowrap;">
                <span *ngIf="row.tipoSede || row.tipoSedeEffettiva">
                  <span *ngIf="row.tipoSede === row.tipoSedeEffettiva" style="font-weight: 700;">
                    {{row.tipoSede || row.tipoSedeEffettiva || '-'}}
                  </span>
                  <span *ngIf="row.tipoSede !== row.tipoSedeEffettiva" style="font-weight: 700;">
                    {{row.tipoSede || '-'}}/{{row.tipoSedeEffettiva || '-'}}
                  </span>
                </span>
                <span *ngIf="!row.tipoSede && !row.tipoSedeEffettiva" style="color: #6c757d; font-style: italic;">-</span>
              </td>
              <td *ngIf="!isImpresa" class="text-center font-['Poppins']">
                <p-tag
                  [value]="row.azienda | uppercase"
                  [style]="{
                    'background-color': '#326F6F',
                    'color': '#ffffff',
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '700',
                    'font-size': '8px',
                    'letter-spacing': '.2px',
                    'cursor': 'pointer'
                  }"
                  class="mr-1"
                ></p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 10px;">
                <p-tag
                  *ngIf="row.vincoloCategoriaLabel || row.vincoloCategoriaCodice"
                  [value]="(row.vincoloCategoriaLabel || row.vincoloCategoriaCodice) | uppercase"
                  [style]="{
                    'background-color': stiliService.getColoreCategoriaVincoloKO(row.vincoloTipologiaID) || stiliService.getColoreCategoriaVincoloOF(row.vincoloCategoriaCodice) || '#e0e0e0',
                    'color': '#ffffff',
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '700',
                    'font-size': '9.5px',
                    'letter-spacing': '.2px',
                    'box-shadow': '0 1px 2px rgba(0,0,0,0.08)'
                  }"
                  [pTooltip]="row.vincoloCategoriaLabel || row.vincoloCategoriaCodice"
                  tooltipPosition="top"
                ></p-tag>
                <span *ngIf="!row.vincoloCategoriaLabel && !row.vincoloCategoriaCodice" style="color: #6c757d; font-style: italic;">-</span>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 10px;">
                <p-tag 
                  *ngIf="row.servizioOF"
                  [value]="row.servizioOF | uppercase" 
                  [style]="getStileStatoOF(row.servizioOF)"
                ></p-tag>
                <span *ngIf="!row.servizioOF" style="color: #6c757d; font-style: italic;">-</span>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; padding: 0.75rem 0.5rem; background: #f8f9fa;">
                <span *ngIf="row.statoOF"
                      [pTooltip]="getTooltipStatoOF(row)"
                      [showDelay]="300"
                      [hideDelay]="0"
                      tooltipPosition="top"
                      [tooltipStyleClass]="'custom-tooltip-stato-of'"
                      [escape]="false"
                      [tooltipDisabled]="!getTooltipStatoOF(row)"
                      style="display: inline-block; cursor: help;">
                  <p-tag 
                    [value]="(row.statoOF?.toUpperCase() === 'LAVORABILE') ? 'ESPLETATA' : row.statoOF" 
                    [style]="getStileStatoOF(row.statoOF)"
                  ></p-tag>
                </span>
                <span *ngIf="!row.statoOF"
                      [pTooltip]="getTooltipStatoOF(row)"
                      [showDelay]="300"
                      [hideDelay]="0"
                      tooltipPosition="top"
                      [tooltipStyleClass]="'custom-tooltip-stato-of'"
                      [escape]="false"
                      [tooltipDisabled]="!getTooltipStatoOF(row)"
                      style="display: inline-block; cursor: help;">
                  <p-tag 
                    [value]="row.vincoloCategoriaLabel || row.vincoloCategoriaCodice" 
                    [style]="{
                      'background-color': stiliService.getColoreCategoriaVincoloOF(row.vincoloCategoriaCodice),
                      'color': '#ffffff',
                      'border-radius': '6px',
                      'padding': '.35em .75rem',
                      'font-weight': '700',
                      'font-size': '11px',
                      'letter-spacing': '.3px',
                      'box-shadow': '0 2px 4px rgba(0,0,0,0.2)'
                    }"
                  ></p-tag>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
    </p-tabView>
  </p-tabPanel>
  
</p-tabView> 